// src/services/apis.js
import { api } from "./apiClient";

// ==============================
// MENU
// ==============================
export const getopcinesMenu = async () => {
    const res = await api.get("opcionesmenu.php");
    return res.data;
};

// ==============================
// TRABAJADORES
// ==============================
export const getTrabajadores = async (idProyecto = 0) => {
    const res = await api.get("trabajadores.php", { params: { idProyecto } });
    return res.data;
};

// ==============================
// FICHAJES
// ==============================
export const inicioFichaje = async (data) => {
    const res = await api.post("fichajes.php", { data });
    return res.data;
};

export const postCorregirFichaje = async (data) => {
    const res = await api.post("corregirFichaje.php", { data });
    return res.data;
};

export const fichajeTotem = async (data) => {
    const res = await api.post("fichajetotem.php", { data });
    return res.data;
};

export const getFichaje = async (fecha) => {
    const res = await api.get("fichajes.php", { params: { fecha } });
    return res.data;
};

export const finFichaje = async (data) => {
    // Tenías '??' y PUT a fichajes.php?? -> lo dejo correcto
    const res = await api.put("fichajes.php", { data });
    return res.data;
};

export const getTodosFichajes = async (fechaDesde, fechaHasta, usuarios) => {
    const res = await api.get("allfichajes.php", {
        params: { fechaDesde, fechaHasta, usuarios },
    });
    return res.data;
};

export const getTodosFichajesDescarga = async (fechaDesde, fechaHasta, usuarios) => {
    const res = await api.post("allfichajesdescarga.php", {
        fechaDesde,
        fechaHasta,
        usuarios,
    });
    return res.data;
};

export const getFichajesUsuario = async (mes, year, id) => {
    const res = await api.get("fichajeUsuario.php", { params: { mes, year, id } });
    return res.data;
};

// ==============================
// RRHH / USUARIOS
// ==============================
export const getOpcionesRrhh = async () => {
    const res = await api.get("opcionesrrhh.php");
    return res.data;
};

export const getUsuarios = async () => {
    const res = await api.get("usuarios.php");
    return res.data;
};
export const getUsuariosMovil = async ({
    page = 1,
    limit = 25,
    search = "",
    foto = "todas",
    historial = false,
    historialLimit = 5,
} = {}) => {
    const res = await api.get("usuariosMovil.php", {
        params: {
            page,
            limit,
            search,
            foto,
            historial: historial ? 1 : 0,
            historial_limit: historialLimit,
        },
    });
    return res.data;
};
export const subirAvatarUsuario = async (id_usuario, foto) => {
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("foto", foto, foto?.name || "avatar.jpg");

    const res = await api.post("subirAvatar.php", formData);
    return res.data;
};
export const actualizarAvatarUsuario = async (id_usuario, foto) => {
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("foto", foto, foto?.name || "avatar.jpg");

    const res = await api.post("actualizarAvatar.php", formData);
    return res.data;
};
export const postUsuario = async (data) => {
    const res = await api.post("usuario.php", { data });
    return res.data;
};

export const delUsuario = async (id) => {
    const res = await api.delete("usuario.php", { data: { data: { id } } });
    return res.data;
};

export const actualizarUsuario = async (data) => {
    const res = await api.put("usuario.php", { data });
    return res.data;
};

// ==============================
// ADMIN / ROLES
// ==============================
export const getOpcionesAdmin = async () => {
    const res = await api.get("opcionesAdministrador.php");
    return res.data;
};

export const getRolesYDepartamentos = async () => {
    const res = await api.get("rolesydepartamentos.php");
    return res.data;
};

export const getEmpleadosProyectos = async () => {
    const res = await api.get("empleadosProyectos.php");
    return res.data;
};

export const actualizarRolesYDepartamentos = async (data, option, rolid) => {
    const res = await api.put("rolesydepartamentos.php", {
        data,
        option,
        rolid,
    });
    return res.data;
};

// ==============================
// CALENDARIO / JORNADAS
// ==============================
export const getTareasCalendario = async () => {
    const res = await api.get("tareasCalendario.php");
    return res.data;
};

export const getJornadas = async () => {
    const res = await api.get("jornadas.php");
    return res.data;
};

export const getTodosFichajesAuditoria = async (fechaDesde, fechaHasta, usuarios) => {
    const res = await api.post("allfichajesauditoria.php", {
        fechaDesde,
        fechaHasta,
        usuarios,
    });
    return res.data;
};

export const putTiempoTrabajadoTarea = async (data, id_tarea) => {
    const res = await api.put("actualizarTiempotrabajadoTarea.php", {
        data,
        id_tarea,
    });
    return res.data;
};

// ==============================
// VERSION / BUSQUEDAS / PENDIENTES
// ==============================
export const getVersion = async (versionLocal) => {
    const res = await api.get("controlVersion.php", {
        params: { versionLocal },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
    });
    return res.data;
};

export const getTodasTareasInfoUnica = async (searchTerm) => {
    const res = await api.get("todastareas.php", {
        params: {
            id: null,
            tipo: 1,
            fechaDesde: "2000-01-29",
            fechaHasta: "2105-01-29",
            estados: "0,1,2,3,4",
            limit: 100,
            page: 1,
            empleados: null,
            clientes: null,
            proyectos: null,
            searchTerm,
        },
    });
    return res.data;
};

export const getFichajesPendientes = async () => {
    const res = await api.get("fichajesPendientes.php");
    return res.data;
};

export const updateFichajePendiente = async (data) => {
    const res = await api.put("fichajesPendientes.php", { data });
    return res.data;
};

export const updateAnularFichaje = async (data) => {
    const res = await api.put("anularFichaje.php", { data });
    return res.data;
};

// ==============================
// RECONOCIMIENTO / VALIDACION POR FOTO
// ==============================
export const cpPorFoto = async ({ id_cuadrilla, foto }) => {
    const formData = new FormData();
    formData.append("id_cuadrilla", String(id_cuadrilla ?? ""));
    formData.append("foto", foto, foto?.name || "foto.jpg");

    const res = await api.post("cpPorFoto.php", formData, {
        headers: {
            "X-Id-Cuadrilla": String(id_cuadrilla ?? ""),
        },
    });

    return res.data;
};

// ==============================
// TARJETAS
// ==============================
export const crearTarjeta = async (data) => {
    const res = await api.post("creartarjeta.php", { data });
    return res.data;
};

export const getTarjetaPorUsuario = async ({ id_usuario }) => {
    const res = await api.get("getTarjetaPorUsuario.php", { params: { id_usuario } });
    return res.data;
};

export const getUsuariosSinTarjeta = async () => {
    const res = await api.get("getUsuariosSinTarjeta.php");
    return res.data;
};

export const eliminarTarjeta = async (data) => {
    const res = await api.post("eliminarTarjeta.php", { data });
    return res.data;
};

// ==============================
// CUADRILLAS / FILTROS
// ==============================
export const getCuadrillas = async (fechaDesde, fechaHasta) => {
    // OJO: en tu código mandabas "data" dentro de params (raro).
    // Lo normal: params directos
    const res = await api.get("partesGrupo.php", { params: { fechaDesde, fechaHasta } });
    return res.data;
};

export const getDetalleParteGrupo = async (id_cuadrilla) => {
    const res = await api.get("detalleParteGrupo.php", {
        params: { id_cuadrilla },
    });
    return res.data;
};

export const getDatosFiltros = async () => {
    const res = await api.get("getDatosFiltros.php");
    return res.data;
};

export const getOpcionesDocumentacion = async () => {
    const res = await api.get("opcionesDocumentacion.php");
    return res.data;
};

export const getDetallePersona = async (id_usuario) => {
    const res = await api.get("detallePersona.php", {
        params: { id_usuario },
    });
    return res.data;
};

export const verificarSesionActiva = async () => {
    const res = await api.get("VerificarToken.php", {
        headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
        },
    });
    return res.data;
};

export const sincronizar = async (payload = {}) => {
    const res = await api.post("sincronizartrabajadores.php", payload);
    return res.data;
};
